import Swiper from 'swiper/swiper-bundle.esm.js';

class SliderLinks {
  public component;
  public trigger;
  constructor() {
    this.component = document.querySelectorAll(
      '[data-component="slider-links"]'
    );
    this.trigger = document.querySelectorAll('[data-trigger="slider-links"]');
    if (this.component && this.trigger) {
      this._init();
    }
  }
  _init() {
    this.trigger.forEach((element) => {
      let mySwiper: Swiper = null;

      const firstImage = element.querySelector('img');
      if (firstImage) {
        firstImage.onload = () => {
          if (mySwiper) {
            mySwiper.update();
          }
        };
      }

      mySwiper = new Swiper(element, {
        spaceBetween: 15,
        preventClicks: true,
        preloadImages: false,
        watchOverflow: true,
        slidesPerView: 'auto',
        freeMode: true,
        lazy: {
          loadOnTransitionStart: true
        }
      });
    });
  }
}

export const sliderLinks = new SliderLinks();
